import React, { FC } from "react"
import { Props, IconProps } from "./types"
import * as styles from "./styles.module.scss"
import Collaboration from "src/components/Icons/Collaboration"
import Level from "src/components/Icons/Level"
import FinishLine from "src/components/Icons/FinishLine"
import Speed from "src/components/Icons/Speed"
import Team from "src/components/Icons/TeamSquare"

const Icon: FC<IconProps> = ({ icon }) => {
  // noinspection JSRedundantSwitchStatement
  switch (icon) {
    case "Collaboration":
      return <Collaboration className={styles.icon} aria-hidden="true" />
    case "Every Level":
      return <Level className={styles.icon} aria-hidden="true" />
    case "Finish Line":
      return <FinishLine className={styles.icon} aria-hidden="true" />
    case "Speed":
      return <Speed className={styles.icon} aria-hidden="true" />
    default:
      return <Team className={styles.icon} aria-hidden="true" />
  }
}

const ToolsTeam: FC<Props> = ({
  className = "",
  title,
  description,
  tools,
}) => (
  <div className={`${className} ${styles.tools}`}>
    <div className={`content-wrapper ${styles.toolsContainer}`}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
      <div className={styles.grid}>
        <div className={styles.card}>
          <Icon icon={tools[0].icon} />
          <h3 className={styles.cardTitle}>{tools[0].title}</h3>
          <p className={styles.cardDescription}>{tools[0].description}</p>
        </div>
        <div className={styles.card}>
          <Icon icon={tools[1].icon} />
          <h3 className={styles.cardTitle}>{tools[1].title}</h3>
          <p className={styles.cardDescription}>{tools[1].description}</p>
        </div>
        <div className={styles.card}>
          <Icon icon={tools[2].icon} />
          <h3 className={styles.cardTitle}>{tools[2].title}</h3>
          <p className={styles.cardDescription}>{tools[2].description}</p>
        </div>
      </div>
    </div>
  </div>
)

export default ToolsTeam
